
const defaultRedirects = {
    AddAddressModal: "People",
    AddEventModal: "Calendar",
    AddPersonModal: "People",
    AddLocationModal: "Calendar",
    AddTaskModal: "Tasks",
    AddTaskTeamModal: "Tasks",
    AddTaskTemplateModal: "Tasks",
    AddLinkModal: "Links",
    AddRoleModal: "Roles",
    AddFolderModal: "Library",
    AddBoardModal: "Connect",
    AddPostModal: "Connect",
    AddConversationModal: "Connect",
    AddSmallGroupModal: "SmallGroups",
    AddSmallGroupSessionModal: "SmallGroups",
    AddSmallGroupTypeModal: "SmallGroups",
    AddBlackoutPeriodModal: "Calendar",
    AddCustomFieldModal: "CustomFields",
    AddCustomFieldSection: "CustomFields",
    CreatePathModal: "Automations",
    CreateStepModal: "Automations",
    CreateFormModal: "Forms",
    AddSongModal: "Library",
    AddRoleFolderModal: "Roles",
}


const redirectToDefault = (router, fromScreen) => {
    if(!router.canGoBack() && defaultRedirects[fromScreen]){
        router.replace(defaultRedirects[fromScreen])
    }
    else if(!router.canGoBack()){
        router.replace("/");
    }
    else{
        router.back();
    }
}

export {
    defaultRedirects,
    redirectToDefault
}